import { useEffect, useState } from "react";
import {
  IApplyOptionProgress,
  ProgressStatus,
} from "../../Interfaces/applyOption";
import { getProgress } from "../../Requests/applyOption";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { CheckOutlined, CloseOutlined } from "@mui/icons-material";
import { ClockCircleOutlined } from "@ant-design/icons";

interface IProps {
  refreshFlag: boolean;
  setRefreshFlag: (flag: boolean) => void;
}

const Progress = ({ refreshFlag, setRefreshFlag }: IProps) => {
  const [progresses, setProgresses] = useState([] as IApplyOptionProgress[]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!refreshFlag) return;
    setLoading(true);
    getProgress()
      .then((resp) => {
        setProgresses(resp);
      })
      .catch(packetErrorHandler)
      .finally(() => {
        setLoading(false);
        setRefreshFlag(false);
      });
  }, [refreshFlag]);

  return (
    <div className="w-full max-w-[70%] overflow-x-auto flex flex-row justify-start items-center gap-3">
      {progresses && progresses.length ? (
        progresses?.map((progress) => (
          <div
            className={`px-3 py-2 ${
              progress.status === ProgressStatus.Success
                ? "bg-green-200"
                : progress.status === ProgressStatus.Fail
                ? "bg-red-200"
                : "bg-gray-200"
            } text-xs flex flex-col justify-start gap-5 items-center rounded`}
          >
            <div className="text-xs whitespace-nowrap">{progress.typeStr}</div>
            <div className="text-xs w-full mt-auto flex flex-row justify-between items-center">
              {progress.status === ProgressStatus.Success ? (
                <CheckOutlined />
              ) : progress.status === ProgressStatus.Fail ? (
                <CloseOutlined />
              ) : (
                <ClockCircleOutlined className="!text-[20px]" />
              )}
              {progress.status !== ProgressStatus.Pending ? (
                progress.lastStatusTime
              ) : (
                <>-</>
              )}
            </div>
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default Progress;
